export default __webpack_public_path__ + "static/Entenda0047-f65d636df17b824997c66e163d7b0acc.jpg";